<template>
  <div class="pay-channel-component">
    <div class="pay-channel-title">请选择支付方式</div>
    <template v-for="(o, i) in visibleList">
      <channel-item
        :channel="o"
        :activeChannel="activeChannel"
        :realPrice="realPrice"
        :key="o.code || i"
        @click.native="changeChannel(o)"
      ></channel-item>
    </template>
    <div
      v-if="showMoreBtn"
      class="show-more-pay-channel"
      @click="moreClick"
    >更多支付方式</div>
    <div
      v-if="showPackUp"
      class="pack-up-pay-channel"
      @click="packUp"
    >收起</div>
  </div>
</template>

<script>
import channelItem from './channelItem'
const CARD_CODE = 'AIRWALLEX_CARD'
const CHANNEL_SHOW_NUM = 2
export default {
  components: {
    channelItem
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    activeChannel: {
      type: Object,
      default: () => {
        return {}
      }
    },
    realPrice: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      expanded: false,
      airwallexCardShow: false
    }
  },
  computed: {
    hasAirwallexCard() {
      return Array.isArray(this.list) && this.list.some(o => o.code === CARD_CODE)
    },
    showMoreBtn() {
      return !this.expanded && (this.hasAirwallexCard || this.list.length > CHANNEL_SHOW_NUM)
    },
    showPackUp() {
      return this.expanded && (this.hasAirwallexCard || this.list.length > CHANNEL_SHOW_NUM)
    },
    visibleList() {
      if (!Array.isArray(this.list)) return []
      return this.list.filter((payway, index) => {
        if (payway.code === CARD_CODE && !this.airwallexCardShow) {
          return false
        }
        if (this.expanded) return true
        if (this.activeChannel && this.activeChannel.code === payway.code) return true
        return index < CHANNEL_SHOW_NUM
      })
    }
  },
  methods: {
    changeChannel(o) {
      this.$emit('changeChannel', o)
    },
    moreClick() {
      this.expanded = true
      this.airwallexCardShow = true
    },
    packUp() {
      this.expanded = false
      this.airwallexCardShow = false
    }
  }
}
</script>
<style lang="less" scoped>
.pay-channel-component {
  margin: 0 auto 15px;
  background-color: #fff;
  padding: 15px 25px 35px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  .pay-channel-title {
    margin-bottom: 16px;
    font-size: 14px;
    color: #666;
  }
  .show-more-pay-channel {
    height: 60px;
    line-height: 60px;
    color: #999;
    border-top: 1px solid #e5e5e5;
    cursor: pointer;
    font-size: 14px;
    text-align: center;
    &::after {
      display: inline-block;
      content: "";
      width: 10px;
      height: 10px;
      background: url("../../../../assets/images/order/bg.png") no-repeat;
      background-position: -20px 0;
      margin-left: 5px;
    }
  }
  .pack-up-pay-channel {
    height: 60px;
    line-height: 60px;
    color: #999;
    border-top: 1px solid #e5e5e5;
    cursor: pointer;
    font-size: 14px;
    text-align: center;
    &::after {
      display: inline-block;
      content: "";
      width: 10px;
      height: 10px;
      background: url("../../../../assets/images/order/bg.png") no-repeat;
      background-position: -20px 0;
      margin-left: 5px;
      transform: rotate(180deg);
    }
  }
}
</style>

